module.exports = __webpack_public_path__ + "static/L2_ux_3_3_eg-19716b5a107213179724dff23ead0d4d.png";